import React from 'react';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

import { Download } from '@mui/icons-material';
import { userServicer } from '../../Commen_Services/user.services';
import { useLoading } from '../../Loader/LoadingContext';

interface ExportToCSVProps {
    csvData: RowData[];
    fileName: string;
    headerName: RowData[];
    filterFieldData: { key: string; value: any }[];
    pageID: string;
    TotalRecord: Number;
    isStatic?: boolean; // new optional prop
    onBeforeExport?: () => Promise<any[]> |  Promise<void> | undefined;
}

interface RowData {
    [key: string]: any;
}

const ExportToCSV: React.FC<ExportToCSVProps> = ({
    csvData,
    fileName,
    headerName,
    filterFieldData,
    pageID,
    TotalRecord,
    isStatic = false, // ➕ default to false
    onBeforeExport
}) => {
    
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const { setLoading } = useLoading();

    const handleExport = async () => {
        setLoading(true);
        try {
            if (isStatic) {
                // Direct export without API
                exportToCSV(csvData, fileName, headerName);
            } else {
                // API-based export
                if (!filterFieldData) return;

                const paginationData = { pageNumber: 1, pageSize: TotalRecord };
                const { data: tabledatafromAPI } = await userServicer.getReportlist(Number(pageID), filterFieldData, paginationData);
                if (tabledatafromAPI) {
                    exportToCSV(tabledatafromAPI.data, fileName, headerName);
                }
            }
        } catch (error) {
            console.error('Export error:', error);
        }
    };

    const exportToCSV = (dataToExport: RowData[], fileName: string, headerName: any[]) => {
        const headers = headerName.map(name => ({ label: name.headerName, key: name.tableFieldName }));

        headers.sort((a, b) => {
            return headerName.find(header => header.tableFieldName === a.key)?.displayOrder -
                   headerName.find(header => header.tableFieldName === b.key)?.displayOrder;
        });

        const data = dataToExport.map(row => {
            const newRow: any = {};
            headers.forEach(header => {
                newRow[header.label] = row[header.key];
            });
            return newRow;
        });

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };

        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const excelData = new Blob([excelBuffer], { type: fileType });

        FileSaver.saveAs(excelData, fileName + fileExtension);
        setLoading(false);
    };

    return (
        <button
            className="btn12"
            disabled={!isStatic && csvData.length === 0}
            style={{ fontSize: 18, paddingTop: 6 }}
            onClick={async () => {
    setLoading(true);
      if (onBeforeExport) {
        const finaldata = await onBeforeExport();
        console.log(finaldata);
        csvData = finaldata as RowData[];  
      }
      await handleExport();       
    }}
        >
            <Download />
        </button>
    );
};

export default ExportToCSV;
